import { isEmpty } from 'lodash';

export function buildAddressLine1(parcelProperties: any) {
  let addressComponents = [parcelProperties.saddno, parcelProperties.saddpref, parcelProperties.saddstr, parcelProperties.saddsttyp, parcelProperties.saddstsuf, parcelProperties.sunit];
  return addressComponents.filter(v => String(v ?? '').trim() !== '')
    .join(' ');
}

export function buildCityStateLine(parcelProperties: any) {
  let addressLine = '';
  if (!isEmpty(parcelProperties.scity)) {
    addressLine += `${parcelProperties.scity}, `;
  }
  if (!isEmpty(parcelProperties.state2)) {
    addressLine += `${parcelProperties.state2.toUpperCase()} `;
  }
  if (!isEmpty(parcelProperties.szip)) {
    addressLine += `${parcelProperties.szip}`;
  }
  return addressLine;
}

export function buildAddressLine(parcelProperties: any) {
  let addressLine = buildAddressLine1(parcelProperties);
  if (!isEmpty(parcelProperties.address2)) {
    addressLine += `${parcelProperties.address2}, `;
  }
  if (!isEmpty(addressLine)) {
    addressLine += ' ';
  }
  addressLine += buildCityStateLine(parcelProperties);
  return addressLine;
}
